import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HanselMaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';

import { HanselButtonsComponent } from '../custom-material-components/hansel-buttons/hansel-buttons.component';
import { HanselTagsComponent } from '../custom-material-components/hansel-tags/hansel-tags.component';
import { HanselDropDownsComponent } from '../custom-material-components/hansel-drop-downs/hansel-drop-downs.component';

@NgModule({
  declarations: [HanselButtonsComponent, HanselTagsComponent, HanselDropDownsComponent],
  imports: [
    CommonModule,
    FormsModule,
    HanselMaterialModule,
    SharedModule
  ],
  exports: [
    HanselButtonsComponent, HanselTagsComponent, HanselDropDownsComponent
  ]
})
export class CustomMaterialComponentsModule { }
